<template>
  <generic-modal :title="$t('attribute')" ref="generic_modal">
    <div class="field">
      <label class="label">{{ $t("name") }}</label>
      <div class="control">
        <input
          class="input"
          type="text"
          v-model="meta.name"
          placeholder="Text input"
        />
      </div>
    </div>
    <!-- <pre>{{ attribute }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "AttributeModal",
  components: { GenericModal },
  data() {
    return {
      attribute: undefined,
      api_host,
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    change_active_tab,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(attribute) {
      let v = this;
      v.set_initial_state();

      if (attribute) {
        v.attribute = attribute;
        v.meta = { ...attribute };
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      v.attribute.name = v.meta.name;
      v.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
};
</script>
<style></style>
